// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__rXLQm {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: auto; }

.styles_modal__N1szl {
  width: 560px;
  height: fit-content;
  max-height: 90vh;
  max-width: 90vw;
  padding: 20px; }
  .styles_modal__container__vh34M {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between; }
    .styles_modal__container_footer__iTECS {
      display: flex;
      justify-content: flex-end;
      gap: 15px;
      margin-top: 16px; }
  .styles_modal__content__L0E7T {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column; }

.styles_algorithmList__6EAsx {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column; }

.styles_input__EL6lX {
  width: 100%; }

label {
  margin: 15px 0 5px 0; }

.styles_textarea__BUpd7 {
  width: 100%;
  border: 1px solid var(--LowEmphasis);
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--HightEmphasis);
  padding: 13px 16px; }
  .styles_textarea__BUpd7:focus {
    border-color: #212121;
    outline: none; }

.styles_containerAlgo__ik8Jm {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0 10px 0;
  transition: all 0.4s;
  cursor: pointer; }
  .styles_containerAlgo__ik8Jm:hover {
    background-color: rgba(254, 97, 0, 0.1); }
  .styles_containerAlgo__content__04zF0 {
    width: calc(100% - 50px);
    display: flex;
    flex-direction: column; }
  .styles_containerAlgo__trash__SkRKP {
    width: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; }
    .styles_containerAlgo__trash__SkRKP span {
      transition: all 0.4s; }
      .styles_containerAlgo__trash__SkRKP span:hover {
        transform: scale(1.1); }
  .styles_containerAlgo__ik8Jm .styles_notDownload__cKwBk {
    display: flex;
    align-items: center;
    gap: 10px; }
    .styles_containerAlgo__ik8Jm .styles_notDownload__cKwBk span {
      font-size: 14px;
      font-weight: 500;
      padding: 3px 10px;
      background-color: #e00606;
      border-radius: 20px;
      color: #ffffff; }
  .styles_containerAlgo__ik8Jm h4 {
    color: var(--surface-on-surface-high-emphasis, #212121);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 150% */
    letter-spacing: 0.15px; }
  .styles_containerAlgo__description__vGuPx {
    padding: 5px 0 15px 0;
    color: var(--surface-on-surface-medium-emphasis, #666);
    font-feature-settings: 'clig' off, 'liga' off;
    text-overflow: ellipsis;
    /* product/Body 2 */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 171.429% */
    letter-spacing: 0.1px; }
  .styles_containerAlgo__image__GZvs6 {
    overflow: hidden;
    color: #666;
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    /* 18px */
    letter-spacing: 0.1px;
    width: 40%; }
  .styles_containerAlgo__footerInfo__u3Szf {
    display: flex;
    justify-content: space-between;
    width: 80%; }

.styles_button_cancel__ghBNB {
  background: #ffffff;
  color: #fe6100; }
  .styles_button_cancel__ghBNB:hover {
    background: #fe6100;
    color: #ffffff; }

.styles_remove__2JOVV {
  width: 560px;
  height: 360px;
  padding: 20px; }
  .styles_remove__container__abRqA {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%; }
    .styles_remove__container__abRqA h4 {
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; }
  .styles_remove__footer__UQo9c {
    display: flex;
    gap: 10px;
    justify-content: flex-end; }
    .styles_remove__footer_del__OsIJx {
      background-color: #e00606; }
`, "",{"version":3,"sources":["webpack://./src/pages/algorithms/styles.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAA;EACb;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B,EAAA;IAC9B;MACE,aAAa;MACb,yBAAyB;MACzB,SAAS;MACT,gBAAgB,EAAA;EAGpB;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB,EAAA;;AAG1B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAA;;AAExB;EACE,WAAW,EAAA;;AAEb;EACE,oBAAoB,EAAA;;AAEtB;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EChBlB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDgBjB,2BAA2B;EAC3B,kBAAkB,EAAA;EANpB;IAQI,qBAAqB;IACrB,aAAa,EAAA;;AAGjB;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB;EACpB,eAAe,EAAA;EANjB;IAQI,uCAAuC,EAAA;EAEzC;IACE,wBAAwB;IACxB,aAAa;IACb,sBAAsB,EAAA;EAExB;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAA;IALpB;MAQG,oBAAoB,EAAA;MARvB;QAUK,qBAAqB,EAAA;EAzB7B;IA8BI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;IAhCb;MAkCM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,mBAAmB;MACnB,cAAc,EAAA;EAvCpB;IA2CI,uDAAuD;IACvD,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IAAE,SAAA;IACnB,sBAAsB,EAAA;EAExB;IACE,qBAAqB;IACrB,sDAAsD;IACtD,6CAA6C;IAC7C,uBAAuB;IACvB,mBAAA;IACA,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IAAE,aAAA;IACnB,qBAAqB,EAAA;EAEvB;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IAAE,SAAA;IACnB,qBAAqB;IACrB,UAAU,EAAA;EAEZ;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU,EAAA;;AAId;EACE,mBAAmB;EACnB,cAAc,EAAA;EAFhB;IAII,mBAAmB;IACnB,cAAc,EAAA;;AAGlB;EACE,YAAY;EACZ,aAAa;EACb,aAAa,EAAA;EACb;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY,EAAA;IALb;MAOG,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;EAGrB;IACE,aAAa;IACb,SAAS;IACT,yBAAyB,EAAA;IACzB;MACE,yBAAyB,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n}\n.modal {\n  width: 560px;\n  height: fit-content;\n  max-height: 90vh;\n  max-width: 90vw;\n  padding: 20px;\n  &__container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    &_footer {\n      display: flex;\n      justify-content: flex-end;\n      gap: 15px;\n      margin-top: 16px;\n    }\n  }\n  &__content {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n}\n.algorithmList {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.input {\n  width: 100%;\n}\nlabel {\n  margin: 15px 0 5px 0;\n}\n.textarea {\n  width: 100%;\n  border: 1px solid var(--LowEmphasis);\n  border-radius: 4px;\n  @include body1;\n  color: var(--HightEmphasis);\n  padding: 13px 16px;\n  &:focus {\n    border-color: #212121;\n    outline: none;\n  }\n}\n.containerAlgo {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 10px 0 10px 0;\n  transition: all 0.4s;\n  cursor: pointer;\n  &:hover {\n    background-color: rgba(254, 97, 0, 0.1);\n  }\n  &__content {\n    width: calc(100% - 50px);\n    display: flex;\n    flex-direction: column;\n  }\n  &__trash {\n    width: 48px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      transition: all 0.4s;\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n  }\n  .notDownload {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    span {\n      font-size: 14px;\n      font-weight: 500;\n      padding: 3px 10px;\n      background-color: #e00606;\n      border-radius: 20px;\n      color: #ffffff;\n    }\n  }\n  h4 {\n    color: var(--surface-on-surface-high-emphasis, #212121);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.15px;\n  }\n  &__description {\n    padding: 5px 0 15px 0;\n    color: var(--surface-on-surface-medium-emphasis, #666);\n    font-feature-settings: 'clig' off, 'liga' off;\n    text-overflow: ellipsis;\n    /* product/Body 2 */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 171.429% */\n    letter-spacing: 0.1px;\n  }\n  &__image {\n    overflow: hidden;\n    color: #666;\n    text-overflow: ellipsis;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 150%; /* 18px */\n    letter-spacing: 0.1px;\n    width: 40%;\n  }\n  &__footerInfo {\n    display: flex;\n    justify-content: space-between;\n    width: 80%;\n  }\n}\n\n.button_cancel {\n  background: #ffffff;\n  color: #fe6100;\n  &:hover {\n    background: #fe6100;\n    color: #ffffff;\n  }\n}\n.remove {\n  width: 560px;\n  height: 360px;\n  padding: 20px;\n  &__container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    h4 {\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 150%;\n    }\n  }\n  &__footer {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    &_del {\n      background-color: #e00606;\n    }\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__rXLQm`,
	"modal": `styles_modal__N1szl`,
	"modal__container": `styles_modal__container__vh34M`,
	"modal__container_footer": `styles_modal__container_footer__iTECS`,
	"modal__content": `styles_modal__content__L0E7T`,
	"algorithmList": `styles_algorithmList__6EAsx`,
	"input": `styles_input__EL6lX`,
	"textarea": `styles_textarea__BUpd7`,
	"containerAlgo": `styles_containerAlgo__ik8Jm`,
	"containerAlgo__content": `styles_containerAlgo__content__04zF0`,
	"containerAlgo__trash": `styles_containerAlgo__trash__SkRKP`,
	"notDownload": `styles_notDownload__cKwBk`,
	"containerAlgo__description": `styles_containerAlgo__description__vGuPx`,
	"containerAlgo__image": `styles_containerAlgo__image__GZvs6`,
	"containerAlgo__footerInfo": `styles_containerAlgo__footerInfo__u3Szf`,
	"button_cancel": `styles_button_cancel__ghBNB`,
	"remove": `styles_remove__2JOVV`,
	"remove__container": `styles_remove__container__abRqA`,
	"remove__footer": `styles_remove__footer__UQo9c`,
	"remove__footer_del": `styles_remove__footer_del__OsIJx`
};
export default ___CSS_LOADER_EXPORT___;
